import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Spinner } from '@/shared/components/atoms/Spinner'

export const PaymentMethodVerifying: React.FC = () => {
	const { t } = useTranslation('common')

	return (
		<div className="bg-card border border-border rounded-xl p-6 mb-4">
			<div className="flex items-center gap-3">
				<Spinner size="lg" spinning={true} />
				<div>
					<h3 className="text-lg font-semibold">
						{t('subscribe.verifying_payment_method')}
					</h3>
					<p className="text-sm text-muted-foreground">
						{t('subscribe.verifying_payment_method_desc')}
					</p>
				</div>
			</div>
		</div>
	)
}
